export interface ApiJob {
  AverageAnnualized: number;
  AverageWeekly: number;
  Division: string;
  DivisionOrder: number;
  Domiciles: Domicile;
  DriverType: string;
  Experience: number;
  HometimeID: number;
  HometimeLabel: string;
  JobID: number;
  LaneDetails: string;
  Openings: number;
  OpenPerDomicile: string;
  Priority: number;
  Status: string;
  TeamType: string;
  Title: string;
  TopAnnualized: number;
  TopWeekly: number;
  UpdateDate: Date;
}
export interface ApiJobById {
  AverageAnnualized: number;
  AverageWeekly: number;
  Division: string;
  DivisionOrder: number;
  Domiciles: Domicile[];
  DriverType: string;
  Experience: number;
  HometimeID: number;
  HometimeLabel: string;
  JobID: number;
  LaneDetails: string;
  Openings: number;
  OpenPerDomicile: string;
  Priority: number;
  Status: string;
  TeamType: string;
  Title: string;
  TopAnnualized: number;
  TopWeekly: number;
  UpdateDate: Date;
}

export interface ApiZipCode {
  City: string;
  State: string;
  zipCode: string;
}

export interface Division {
  Description: string;
  JobBullets: string[];
  JobType: string;
}

export interface Domicile {
  City: string;
  JobDomicileId: number;
  JobID: number;
  Radius: number;
  State: string;
  StateCode: string;
}

export interface DomicileSmall {
  city: string;
  state: string;
}

export interface Job {
  city: string;
  description: string;
  division: string;
  domicileId: number;
  domiciles: DomicileSmall[];
  driverType: string;
  experience: string;
  hideWage: boolean;
  hideWageYear: boolean;
  homeTime: string;
  jobId: string;
  state: string;
  title: string;
  wageAverageAnnualized: string;
  wageAverageWeekly: string;
  wageTopAnnualized: string;
  wageTopWeekly: string;
}

export interface JobFilter {
  divisions: string[];
  driverTypes: string[];
  experiences: number[];
  hometimes: string[];
  location: string;
}

export interface QuickApply {
  agreedToTerms: boolean;
  allowTexting: boolean;
  applicationType: string;
  cdlExperience: string;
  cdlHolder: boolean;
  cellphone: string;
  city: string;
  emailAddress: string;
  firstName: string;
  jobs: SmallJob[];
  lastName: string;
  movingViolationCount: string;
  over21: boolean;
  recordSource: string;
  state: string;
  zipCode: string;
}

export interface SmallJob {
  domicileId: string;
  jobId: string;
}

export const States = {
  Arizona: 'AZ',
  Alabama: 'AL',
  Alaska: 'AK',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
};
